import { render } from "./CreateReceipt.vue?vue&type=template&id=b0a319fa&scoped=true"
import script from "./CreateReceipt.vue?vue&type=script&lang=js"
export * from "./CreateReceipt.vue?vue&type=script&lang=js"

import "./CreateReceipt.vue?vue&type=style&index=0&id=b0a319fa&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a319fa"]])

export default __exports__